export default "__VITE_ASSET__cbff25e9__"